import { useState } from "react";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import GenericTable from "../Tables/GenericTable";
import DefaultCell from "../Tables/components/DefaultCell";
import { GET_ALL_QUERY, GetAllGql } from "layouts/ecommerce/Subjects/queries/getAll";
import { ApiCourseWithSetData } from "data/queries/ApiCourse";
import CreateSubject from "layouts/ecommerce/Subjects/Create";
import { CreateGql } from "layouts/ecommerce/Subjects/queries/create";
import ModalCustom from "../ModalCustom";
import { ModalTableSelect } from "../JsonForm/renderers/SelectMultiple/types";
import { JsonFormsStateProps } from "../JsonForm/JsonFormsComponent/types";

const btnStyle = {
  border: "1px solid #7b809a",
  width: "100%",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: 1,
};

const btnStyleRemove = {
  ...btnStyle,
  border: "1px solid #F44335",
  color: "#F44335",
};

export default function ModalSubjectsSelect({
  ids,
  handleOpen,
  onChange,
  open,
}: ModalTableSelect<{
  id: number;
  name: string;
  group?: string;
  hours: number;
  position?: number;
  ref?: string;
}>) {
  const [state, setState] = useState<
    JsonFormsStateProps<{
      id: number;
      name: string;
      description: string;
      hours: number;
      group: string;
      position: number;
      ref: string;
    }>
  >({});
  const [showCreateForm, setShowCreateForm] = useState(false);
  const handleShowCreateForm = () => setShowCreateForm(true);
  const handleHideCreateForm = () => setShowCreateForm(false);

  const handleCreateSuccess = (data: CreateGql) => {
    if (data?.createSubject) {
      onChange(data.createSubject);
      handleHideCreateForm();
      setState((prev) => ({ ...prev, data: null }));
    } else {
      alert("ops, algo deu errado");
    }
  };

  return (
    <ModalCustom
      onClose={handleOpen}
      open={open}
      sx={{
        "& .head": {
          justifyContent: "center",
          width: "100%",
        },
        "& .css-aim41u": {
          marginLeft: "0 !important",
        },
      }}
    >
      <MDBox>
        <MDBox paddingTop="30px" sx={{ display: showCreateForm ? "" : "none" }}>
          <MDBox display="flex" justifyContent="flex-end" padding="24px" paddingBottom="0">
            <MDButton variant="gradient" color="warning" onClick={handleHideCreateForm}>
              Voltar Para lista
            </MDButton>
          </MDBox>

          <CreateSubject
            showNavBar={false}
            onSuccess={handleCreateSuccess}
            state={state}
            setState={setState}
          />
        </MDBox>

        <MDBox paddingTop="30px" sx={{ display: showCreateForm ? "none" : "" }}>
          <GenericTable<GetAllGql>
            initialVariables={{
              page: 1,
              perPage: 10,
              search: null,
            }}
            useDefaultFilter={false}
            path=""
            query={GET_ALL_QUERY}
            formatRows={(data) => data.Subjects.items}
            formatPagination={(data) => data.Subjects.paginationInfo}
            title=""
            ApiSetData={ApiCourseWithSetData}
            columnsTable={[
              {
                Header: "id",
                accessor: "id",
                Cell: ({ value, cell }: any) => (
                  <MDButton
                    sx={ids.includes(Number(value)) ? btnStyleRemove : btnStyle}
                    onClick={() => onChange(cell.row.original)}
                  >
                    {ids.includes(Number(value)) ? "Remover" : "Adicionar"}
                  </MDButton>
                ),
              },
              {
                Header: "Grupo",
                accessor: "group",
                Cell: ({ value }: any) => <DefaultCell value={value} />,
              },
              {
                Header: "Posição",
                accessor: "position",
                Cell: ({ value }: any) => <DefaultCell value={value} />,
              },
              {
                Header: "Nome",
                accessor: "name",
                Cell: ({ value }: any) => <DefaultCell value={value} />,
              },
              {
                Header: "Horas",
                accessor: "hours",
                Cell: ({ value }: any) => <DefaultCell value={value} />,
              },
              {
                Header: "Ref",
                accessor: "ref",
                Cell: ({ value }: any) => <DefaultCell value={value} />,
              },
            ]}
            buttonCreate={
              <MDButton
                variant="gradient"
                color="info"
                onClick={handleShowCreateForm}
                sx={{ margin: "5px 15px" }}
              >
                NOVA MATÉRIA
              </MDButton>
            }
          />
        </MDBox>
      </MDBox>
    </ModalCustom>
  );
}
